<div class="titleWrapper">
  <div (click)="switchSet(false)" [class.activeSwitch]="!isSwitchSet" class="switchText">
    {{ 'container' | translate }} I
  </div>
  @if (setActive) {
    <div class="spaceBetweenButtons">|</div>
  }
  @if (setActive) {
    <div
      (click)="switchSet(true)"
      [class.activeSwitch]="isSwitchSet"
      class="switchText"
      >
      {{ 'container' | translate }} II
    </div>
  }
</div>
<form [formGroup]="form" #f="ngForm">
  <div class="form">
    <div class="formWrapper">
      <div class="checkboxWrapper">
        <gl-checkbox
          [defaultChecked]="this.form.get('gravityShowCenter').value"
          formControlName="gravityShowCenter"
          >
          {{ 'show_gravity_center' | translate }}
        </gl-checkbox>
        <gl-modal-hint class="infoWrapper">
          <div class="infoImageWrapper">
            <img class="infoImage" src="../../../../../assets/svg/gravityCenterA.svg" />
            <img class="infoImage" src="../../../../../assets/svg/gravityCenterB.svg" />
          </div>
          <p>
            {{ 'indicate_max_deviation_info' | translate }}
          </p>
        </gl-modal-hint>
      </div>

      @if (!isSwitchSet) {
        <div class="formColumn">
          <div class="inputWrapper">
            <div>{{ 'length_tolerance' | translate }}</div>
            <div class="inputRow">
              <gl-input-container class="input" [isErrorVisible]="true">
                <input formControlName="gravityTrailerLengthTolerance" normal-input type="number" />
              </gl-input-container>
            </div>
          </div>
          <div class="inputWrapper">
            <div>{{ 'width_tolerance' | translate }}</div>
            <div class="inputRow">
              <gl-input-container class="input" [isErrorVisible]="true">
                <input formControlName="gravityTrailerWidthTolerance" normal-input type="number" />
              </gl-input-container>
            </div>
          </div>
          <div class="inputWrapper">
            <div>{{ 'container_weight' | translate }}</div>
            <div class="inputRow">
              <gl-input-container class="input" [isErrorVisible]="true">
                <input formControlName="trailerContainerWeight" normal-input type="number" />
              </gl-input-container>
            </div>
          </div>
        </div>
      }

      @if (isSwitchSet) {
        <div class="formColumn">
          <div class="inputWrapper">
            <div>{{ 'length_tolerance' | translate }}</div>
            <div class="inputRow">
              <gl-input-container class="input" [isErrorVisible]="true">
                <input
                  formControlName="gravitySemiTrailerLengthTolerance"
                  normal-input
                  type="number"
                  />
              </gl-input-container>
            </div>
          </div>
          <div class="inputWrapper">
            <div>{{ 'width_tolerance' | translate }}</div>
            <div class="inputRow">
              <gl-input-container class="input" [isErrorVisible]="true">
                <input
                  formControlName="gravitySemiTrailerWidthTolerance"
                  normal-input
                  type="number"
                  />
              </gl-input-container>
            </div>
          </div>
          <div class="inputWrapper">
            <div>{{ 'container_weight' | translate }}</div>
            <div class="inputRow">
              <gl-input-container class="input" [isErrorVisible]="true">
                <input
                  formControlName="semiTrailerContainerWeight"
                  max="100"
                  min="-100"
                  normal-input
                  type="number"
                  />
              </gl-input-container>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="visualization">
      <gl-loading-space-preview
        [height]="264"
        [loadingSpaceType]="loadingSpace"
        [width]="370"
      ></gl-loading-space-preview>
    </div>
  </div>
  <div class="buttonRow">
    <button (click)="delete()" outline-icon-button type="reset">
      <gl-icon name="delete"></gl-icon>
    </button>
    <button outline-icon-button type="button">
      <gl-icon name="startArrangement"></gl-icon>
    </button>
  </div>
</form>
